import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconEye(rest) {
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <g
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </g>
    </Icon>
  )
}
